'use client';

import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import { MOBILE_WIDTH } from "@/constants";
import Button from "./Button";
import { useRouter, usePathname } from "next/navigation";
import {FiPlus} from "react-icons/fi";
import { motion, AnimatePresence } from "framer-motion";
import Image from "next/image";
const FloatingRotateButton = ({
    className = '',
    href,
    imgSrc,
    imgAlt,
    onClick,
    footerObs,
    hideDetailFloating,
}) => {

  const router = useRouter();
  const [isFixed, setIsFixed] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
  const pathName = usePathname();
    useEffect(() => {
      if (!footerObs?.current) return;

      const floatingObs = new IntersectionObserver((ent, obs) => {
          ent.forEach((e) => {
              e.isIntersecting === true ? (
                setIsFixed(true)
              ) : (
                setIsFixed(false)
              )
          });
      });
      floatingObs.observe(footerObs?.current);
    }, [footerObs, pathName]);
    const toggleList = () => {
        setIsOpen((prev) => !prev);
    };

    useEffect(() => {
        setIsOpen(false);
    }, [pathName]);



    const listContainerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1,
                delayChildren: 0.05,
            },
        },
    };

    const listItemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.5,
                ease: [0.25, 0.1, 0.25, 1], // ease
                delay: i * 0.08,
            },
        }),
        exit: (i) => ({
            opacity: 0,
            y: 30,
            transition: {
                duration: 0.3,
                ease: "easeIn",
                delay: i * 0.05,
            },
        }),
    };

    const items = [
        {
            title: "카카오톡 채널",
            path: "http://pf.kakao.com/_ixjiTG",
            icon: "/img/kakao-icon.png",
            target: true
        },
        {
            title: "네이버 블로그",
            path: "https://blog.naver.com/innerviewit",
            icon: "/img/blog-icon.png",
            target: true
        },
        {
            title: "뉴스레터 구독",
            path: "/subscribe",
            icon: "/img/subscribe-icon.png",
            target: null
        },
    ];

  return (
        <FloatingButtonWrap className={`${className} ${isFixed ? 'fixed' : ''}`}>
            <FloatingButtonEtc onClick={toggleList}>
                <div className={"show-btn-wrap"}>
                    <div className={`${isOpen ? "active" : ""} show-btn`} >
                        <FiPlus size={45}/>
                    </div>
                </div>
                <AnimatePresence>
                    {isOpen && (
                        <motion.div
                            className="float-list"
                            variants={listContainerVariants}
                            initial="hidden"
                            animate="visible"
                            exit="hidden"
                        >
                            {items.slice().reverse().map((item, idx) => (
                                <motion.div
                                    className="list-item"
                                    key={idx}
                                    variants={listItemVariants}
                                    custom={idx}
                                    initial="hidden"
                                    animate="visible"
                                    exit="exit"
                                >
                                    {item.target ? (
                                        <a
                                            href={item.path}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="item-wrap"
                                            onClick={() => setIsOpen(false)}
                                        >
                                            <div className="icon">
                                                <Image src={item.icon} alt="리스트 아이콘" />
                                            </div>
                                            {item.title}
                                        </a>
                                    ) : (
                                        <div
                                            className="item-wrap"
                                            onClick={() => {
                                                setIsOpen(false);
                                                router.push(item.path);
                                            }}
                                        >
                                            <div className="icon">
                                                <Image src={item.icon} alt="리스트 아이콘" />
                                            </div>
                                            {item.title}
                                        </div>
                                    )}
                                </motion.div>
                            ))}
                        </motion.div>
                    )}
                </AnimatePresence>
            </FloatingButtonEtc>
            {!hideDetailFloating && (
                <FloatingRotateButtonCont onClick={href ? () => router.push(href) : onClick}>
                    <img src={imgSrc} alt={imgAlt} />
                </FloatingRotateButtonCont>
            )}

        </FloatingButtonWrap>
  );
}

const AniRotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  0% {
    transform: rotate(-360deg);
  }
`;




const FloatingButtonEtc = styled.div`
    width: 6.225rem;
    height: 6.225rem;

    cursor: pointer;
    position: relative;
    .show-btn-wrap{
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 2px solid #fff;
        position: relative;
        background: linear-gradient(95deg, rgba(214, 226, 255, 0.3) 13.48%, rgba(129, 164, 255, 0.3) 83.07%);
        transition: border var(--trans_time);
        &::after {
            content: '';
            position: absolute;
            top: -2px;
            left: -2px;
            width: calc(100% + 4px);
            height: calc(100% + 4px);
            background: linear-gradient(95deg, rgb(214, 226, 255) 13.48%, rgb(129, 164, 255) 83.07%);
            opacity: 0;
            transition: var(--trans_time);
            border-radius: 50%;
        }
        &:hover {
            border-color: transparent;

            &::after {
                opacity: 1;
            }

            svg {
                filter: invert(1);
            }
        }
    }
    .show-btn{
        transition: all ease-in-out .3s;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10;
         svg{
             width: 100%;
             height: 100%;
         }
        &.active{
            transform: translate(-50%, -50%) rotate(135deg);
        }
     }
    .float-list {
        display: flex;
        flex-direction: column;
        gap: 2px;
        position: absolute;
        bottom: calc(6.225rem + 12px);
        right: 0;
        z-index: 10;
        width: 160px;
        background: #FFFFFF;
        border-radius: 8px;
        overflow: hidden;
        padding: 8px 6px;
    }



    .list-item {
        border-radius: 4px;
        cursor: pointer;
        background: transparent;
        transition: background 0.2s;
        font-weight: 500;
        line-height: 100%;
        letter-spacing: -0.02em;
        height: 28px;
        width: 100%;

        &:hover {
            background: linear-gradient(0deg, #F2F5FF, #F2F5FF), linear-gradient(323.67deg, #D6E2FF 12.03%, #FFFFFF 113.12%);
        }
        .item-wrap{
            display: flex;
            align-items: center;
            height: 100%;
            gap: 8px;
            color: #666666;
            font-size: 12px;
            .icon{
                img{
                    width: 16px;
                    height: 16px;
                }
            }
        }
    }
    @media screen and (max-width: ${MOBILE_WIDTH}px) {
        width: 4.5rem;
        height: 4.5rem;
        .float-list {
            padding: 6px 4px;
            width: 120px;
            bottom: calc(4.5rem + 12px);
        }
        .list-item {
            .item-wrap {
                gap: 5px;

                .icon {
                    img {
                        width: 12px;
                        height: 12px;
                    }
                }
            }
        }
    }
`



const FloatingButtonWrap = styled.div`
    position: fixed;
    z-index: calc(var(--navbar_index) - 1);
    right: 8rem;
    bottom: 8rem;
    display: flex;
    flex-direction: column;
    align-items: end;
    gap: 20px;
    @media screen and (max-width: ${MOBILE_WIDTH}px) {
        gap: 10px;
        right: 3rem;
    }
    &.fixed {
        position: absolute;
    }
`
const FloatingRotateButtonCont = styled(Button)`

  width: 11rem;
  height: 11rem;
  padding: 0.9rem;
  border-radius: 50%;
  border: 2px solid #fff;
  background: linear-gradient(95deg, rgba(214, 226, 255, 0.3) 13.48%, rgba(129, 164, 255, 0.3) 83.07%);
  transition: border var(--trans_time);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;



  &::after {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    width: calc(100% + 4px);
    height: calc(100% + 4px);
    background: linear-gradient(95deg, rgb(214, 226, 255) 13.48%, rgb(129, 164, 255) 83.07%);
    opacity: 0;
    transition: var(--trans_time);
    border-radius: 50%;
  }

  img {
    position: relative;
    z-index: 3;
    width: 100%;
    height: 100%;
    animation: ${AniRotate} 7s linear infinite;
    transition: filter var(--trans_time);
  }

  &:hover {
    border-color: transparent;

    &::after {
      opacity: 1;
    }

    img {
      filter: invert(1);
    }
  }

  @media screen and (max-width: ${MOBILE_WIDTH}px) {
    //right: 24px;
    //bottom: 32px;
    width: 80px;
    height: 80px;
    padding: 7px;
    border-width: 1px;

    img {
      animation-duration: 8s;
    }
  }
`;


export default FloatingRotateButton;
